<script>
    import * as Utils from '@js/modules/utils';
    import I18n from '@js/modules/translations';
    import Computation from '@js/modules/computation';

    import {searchStore} from '@js/stores/searchStore';

    import SearchFilterItem from '@js/components/search/filter/SearchFilterItem.svelte';

    const {
        allFilters,
        onFilterUpdate
    } = $props();

    const initialFilters = {
        rideTypes: new Set(allFilters.rideTypes),
        levels: new Set(allFilters.levels),
        distance: new Set([allFilters.distance.min, allFilters.distance.max]),
        duration: new Set([allFilters.duration.min, allFilters.duration.max])
    };

    const onFilterChange = (filterType, filterName, filterData, checked) => {
        const selectedFilters = {...searchStore.selectedFilters};

        if (filterType === 'range') {
            if ((1 - allFilters[filterName].min / filterData[0]) < 0.08 && (1 - filterData[1] / allFilters[filterName].max) < 0.08) {
                selectedFilters[filterName] = undefined;
            } else {
                selectedFilters[filterName] = new Set(filterData);
            }
        } else if (filterType === 'select') {
            if (!selectedFilters[filterName]) {
                selectedFilters[filterName] = new Set(initialFilters[filterName]);
            }

            if (checked) {
                selectedFilters[filterName].add(filterData.id);
            } else {
                selectedFilters[filterName].delete(filterData.id);
            }
        }

        searchStore.selectedFilters = selectedFilters;

        _updateFilters();
    };

    const _updateFilters = Utils.debounce(() => {
        onFilterUpdate(searchStore.selectedFilters);
    }, 400);

    const _formatFilterEntry = (all, available) => {
        return all.map((filter) => ({
            id: filter,
            name: filter,
            count: available ? available[filter] || 0 : 0
        }));
    };
</script>

{#if Utils.isPresent($searchStore.query)}
    <div class="mt-2 mx-4">
        <div class="flex items-center flex-wrap justify-start gap-3">
            <SearchFilterItem type="select"
                              name={I18n.t('js.search.index.filters.ride_type')}
                              elementId="rideTypes"
                              elements={_formatFilterEntry(allFilters.rideTypes, $searchStore.availableFilters.ride_type).map((rideType) => ({
                                      id: rideType.name,
                                      name: I18n.t('js.ride.enums.ride_type')[rideType.name],
                                      count: rideType.count
                                  }))}
                              selectedElements={$searchStore.selectedFilters.rideTypes || initialFilters.rideTypes}
                              onFilterChange={onFilterChange}/>

            <SearchFilterItem type="select"
                              name={I18n.t('js.search.index.filters.level')}
                              elementId="levels"
                              elements={_formatFilterEntry(allFilters.levels, $searchStore.availableFilters.level).map((level) => ({
                                      id: level.id,
                                      name: I18n.t('js.ride.enums.level')[level.name],
                                      count: level.count
                                  }))}
                              selectedElements={$searchStore.selectedFilters.levels || initialFilters.levels}
                              onFilterChange={onFilterChange}/>

            <SearchFilterItem type="range"
                              name={I18n.t('js.search.index.filters.distance')}
                              elementId="distance"
                              elements={[allFilters.distance.min, allFilters.distance.max]}
                              elementFormatter={(element) => Computation.formatDistance(element, {
                            smartUnit: true,
                            kUnit: false,
                            decimalLimit: 1
                        })}
                              selectedElements={$searchStore.selectedFilters.distance || initialFilters.distance}
                              onFilterChange={onFilterChange}/>

            <SearchFilterItem type="range"
                              name={I18n.t('js.search.index.filters.duration')}
                              elementId="duration"
                              elements={[allFilters.duration.min, allFilters.duration.max]}
                              elementFormatter={(element) => Computation.formatDuration(element, {withSeconds: false})}
                              selectedElements={$searchStore.selectedFilters.duration || initialFilters.duration}
                              onFilterChange={onFilterChange}/>
        </div>
    </div>
{/if}
